import Joi from 'joi';

export const schema = Joi.object({
  giftCardNumber: Joi.string()
    .pattern(new RegExp('(^[0-9]{7}$)|^[0-9]{20}$'))
    .error(new Error('El número debe contener 7 o 20 dígitos.')),
});
